
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#1a1b1e] to-[#1e2025]">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(16,185,129,0.12),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_60%,rgba(249,115,22,0.08),transparent_50%)]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#252830] border border-gray-700 rounded-full mb-10 shadow-lg">
          <span className="w-2 h-2 bg-primary rounded-full animate-pulse"></span>
          <span className="text-base font-bold text-gray-300">{t('hero.badge')}</span>
        </div>

        <h1 className="text-6xl sm:text-7xl lg:text-8xl font-display font-black text-white mb-8 leading-tight">
          {t('hero.title1')}
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
            {t('hero.title2')}
          </span>
        </h1>

        <p className="text-2xl sm:text-3xl text-gray-400 mb-12 max-w-4xl mx-auto leading-relaxed font-semibold whitespace-pre-line">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mb-12">
          <Link
            to="/generator"
            className="group px-10 py-5 bg-primary text-white rounded-full font-bold text-xl hover:bg-primary-600 transition-all hover:shadow-2xl hover:shadow-primary/40 flex items-center gap-3 cursor-pointer whitespace-nowrap"
          >
            {t('hero.ctaPrimary')}
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-2 transition-transform"></i>
          </Link>
          <a
            href="#features"
            className="px-10 py-5 bg-[#252830] border-2 border-gray-700 text-gray-200 rounded-full font-bold text-xl hover:bg-[#2d3139] transition-all hover:shadow-xl flex items-center gap-3 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-2xl"></i>
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-10 text-gray-400 text-base font-bold">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl text-primary"></i>
            <span>{t('hero.trust1')}</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl text-primary"></i>
            <span>{t('hero.trust2')}</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-2xl text-primary"></i>
            <span>{t('hero.trust3')}</span>
          </div>
        </div>

        <div className="mt-20 relative">
          <div className="absolute inset-0 bg-gradient-to-t from-[#1e2025] via-transparent to-transparent z-10"></div>
          <img
            src="https://public.readdy.ai/ai/img_res/726293e4ad72bb43ac9e310e68ef35fa.jpg"
            alt="AI Generated Examples"
            className="w-full max-w-6xl mx-auto rounded-2xl shadow-2xl border border-gray-800"
          />
        </div>
      </div>
    </section>
  );
}
